module.exports = __webpack_public_path__ + "static/media/4.3438e278.png";


//////////////////
// WEBPACK FOOTER
// ./src/emoji/4.png
// module id = 222
// module chunks = 0